import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import React from "react";
import { twMerge } from "tailwind-merge";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    title?: string;
    classes?: {
        backdrop?: string;
        dialogContainer?: string;
        dialogPanel?: string;
        title?: string;
    };
    hideCloseButton?: boolean;
};

function BaseDialog({
    isOpen,
    onClose,
    children,
    title,
    classes,
    hideCloseButton,
}: Props) {
    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-50">
            <DialogBackdrop
                className={twMerge(
                    "fixed inset-0 bg-black/70",
                    classes?.backdrop
                )}
            />
            <div
                className={twMerge(
                    "fixed inset-0 flex w-screen items-center justify-center p-4",
                    classes?.dialogContainer
                )}
            >
                <DialogPanel
                    className={twMerge(
                        "relative flex flex-col w-full max-w-[800px] h-full max-h-[400px] bg-white p-6 rounded-[4px]",
                        classes?.dialogPanel
                    )}
                >
                    {!hideCloseButton && (
                        <button
                            className="absolute top-0 right-0 m-3 size-9 rounded-full hover:bg-gray-100"
                            onClick={onClose}
                        >
                            <XMarkIcon className="size-full p-1.5" />
                        </button>
                    )}
                    {title ? (
                        <DialogTitle
                            className={twMerge(
                                "text-center font-semibold text-[22px] text-blue-dark mb-3",
                                classes?.title
                            )}
                        >
                            {title}
                        </DialogTitle>
                    ) : null}
                    {children}
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default BaseDialog;
